import api from '@/api/'

export const strategyCommand = {
  edit(data) {
    this.isEdit = true
    this.visible = true
    this.$nextTick(() => {
      this.waitItem = { ...data, line_id: Number(data.line_id) }
    })
  },
  delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteSpecial({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
